import { addAction, addError } from '@infra/datadog/tracking';

export type VideoLogContext = Record<string, unknown>;

// Ошибка видеоконтроля для Datadog. Имя `Video<Событие>Error`, как у ошибок API по сервисам:
// по префиксу фильтруются все ошибки видео, по имени — каждая. Исходная ошибка в cause
export class VideoError extends Error {
  constructor(
    public readonly event: string,
    cause: unknown,
  ) {
    const inner = cause instanceof Error ? cause.message : String(cause);
    super(`${event}: ${inner}`, cause instanceof Error ? { cause } : undefined);
    this.name = `Video${pascalCase(event.replace(/_(failed|rejected|error)$/, ''))}Error`;
  }
}

// Журнал видеоконтроля в Datadog: ошибки — RUM errors (`VideoError`), события — custom actions,
// у всех общий контекст (роль, камера, турнир, комната). В консоль из кода видео не пишем:
// отладка только через Datadog, вне прода события никуда не идут
export class VideoLog {
  constructor(private context: VideoLogContext) {}

  // Контекст пополняется по ходу: комната и сервер известны после обмена билета
  set(extra: VideoLogContext): void {
    this.context = { ...this.context, ...extra };
  }

  child(extra: VideoLogContext): VideoLog {
    return new VideoLog({ ...this.context, ...extra });
  }

  event(name: string, data?: VideoLogContext): void {
    addAction(`video.${name}`, { feature: 'video', ...this.context, ...data });
  }

  error(name: string, e: unknown, data?: VideoLogContext): void {
    const error = e instanceof VideoError ? e : new VideoError(name, e);
    addError(error, { feature: 'video', event: `video.${name}`, ...this.context, ...data });
  }
}

/*
    ____,-------------------------------,____
    \   |            Helpers            |   /
    /___|-------------------------------|___\
*/

// connect_failed → ConnectFailed
function pascalCase(s: string): string {
  return s
    .split('_')
    .filter(Boolean)
    .map((part) => part[0]!.toUpperCase() + part.slice(1))
    .join('');
}
